module.exports = __webpack_public_path__ + "img/programme-government-m.cae8839e.png";